import { Input } from '@trackman/web-shared-components';
import { Select } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

const locationOptions = [
  { label: 'In person', value: 'InPerson' },
  { label: 'Online', value: 'Online' },
];

export const LocationSettings = observer(() => {
  const es = useStores().trackmanEventsEditorStore;

  return (
    <div className='admin-edit-section'>
      <h2>Location*</h2>
      <div className='inputs-container event-location-settings'>
        <Select
          label=''
          value={es.eventItem.locationType ?? ''}
          className='narrow-select'
          required
          onChange={(event) => {
            es.eventItem.locationType = event.target.value as string;

            if (event.target.value === 'Online') {
              es.eventItem.location = null;
            }
          }}
          selectOptions={locationOptions.map((location) => {
            return {
              label: location.label,
              value: location.value,
            };
          })}
        />
        <Input
          label='City name'
          value={es.eventItem.location ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => (es.eventItem.location = e.currentTarget.value)}
          disabled={es.eventItem.locationType === 'Online'}
        />
      </div>
    </div>
  );
});

export default LocationSettings;
